import { Component, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { Visibility } from '../../../services/brain-parameters.service';
import { NgClass } from '@angular/common';

@Component({
  selector: 'app-brain-param-visibility',
  standalone: true,
  template: `
    <div class="label visibility" [ngClass]="visibility()" title="{{ 'Visibility.' + visibility() | translate }}">
      <span>{{ abbrevs[visibility()] }}</span>
    </div>
  `,
  imports: [TranslatePipe, NgClass],
  styleUrls: ['./brain-param-visibility.component.scss'],
})
export class BrainParamVisibilityComponent {
  public visibility = input.required<Visibility>();

  abbrevs: Record<Visibility, string> = { admin: 'A', adminCluster: 'C', advanced: 'A', expert: 'E' };
}
